import LegalPage from "./LegalPage";

export default function TrademarkPage() {
  return (
    <LegalPage title="Trademarks and attribution">
      <p>
        The Cowork Cookbook is <strong>not affiliated with, sponsored by, or endorsed by Microsoft
        Corporation</strong>.
      </p>
      <p>
        Microsoft, Microsoft 365, Microsoft 365 Copilot, Dynamics 365, and related names,
        logos, and product names are trademarks of Microsoft Corporation. Their use on this site
        is{" "}
        <a href="https://en.wikipedia.org/wiki/Nominative_use">nominative fair use</a>: it
        describes interoperability between this catalog and Microsoft&apos;s products and does not
        suggest sponsorship or endorsement.
      </p>
      <p>
        &quot;Cowork&quot; is used here as the common name of the Microsoft 365 Copilot Cowork
        product feature. To the maintainer&apos;s knowledge it is not a registered trademark of
        Microsoft Corporation as of this writing; if that changes we will update this notice.
      </p>
      <p>
        If you have a trademark concern, contact the maintainers via the{" "}
        <a href="https://github.com/seangalliher/CoworkCookBookWebApp/issues">web app repo</a>.
      </p>
    </LegalPage>
  );
}
